import { Component } from '@angular/core';

import { EaglesocietyService } from 'src/app/Services/eaglesociety.service';
import { BookingGuestsService } from 'src/app/Services/booking-guests.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { UserData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-eagle-society-promo',
  templateUrl: './eagle-society-promo.component.html',
  styleUrls: ['./eagle-society-promo.component.css'],
  providers: [EaglesocietyService, BookingGuestsService],
})
export class EagleSocietyPromoComponent {
  userdata?: UserData;
  folioid: number | undefined;
  bookingID: number | undefined;
  OBPortalSvcURL = '';

  EagleSocietyInfo: any;
  eaglesocietydata: any;
  BookingGuestsInfo: any;
  bookingguestsdata: any;

  constructor(
    private EagleSocietyService: EaglesocietyService,
    private BookingGuestsService: BookingGuestsService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    //this.folioid = this.userdata?.folioID!;
    this.folioid = 3738335;
    this.getBookingGuests();
  }
  getBookingGuests() {
    this.bookingID = this.userdata?.rebuid!;
    this.bookingguestsdata = this.BookingGuestsService.GetBookingGuests(
      this.bookingID
    ).subscribe((bookingguestsdata: any) =>
      this.setBookingGuests(bookingguestsdata)
    );
  }
  setBookingGuests(resdata: any) {
    this.bookingguestsdata = resdata;
    if (this.bookingguestsdata.GetBookingGuests.Result.Status == 'A') {
      this.BookingGuestsInfo =
        this.bookingguestsdata.GetBookingGuests.BookingGuestList;
    }
  }
  UpdateEagleSociety(guest: any) {
    this.eaglesocietydata = this.EagleSocietyService.MakeES(
      guest.refFolfolioId
    ).subscribe((eaglesocietydata) =>
      this.setEagleSociety(eaglesocietydata, guest)
    );
  }

  setEagleSociety(resdata: any, guest: any) {
    this.eaglesocietydata = resdata;
    if (this.eaglesocietydata.ResUpdateLoyaltyLevel.Result.Status == 'A') {
      guest.loyaltylevel = 'ES';

      this.dialog.open(AlertDialogComponent, {
        data: {
          alertMessage:
            'Thank you for signing up for our Eagle Society program.',
        },
      });

      // this.EagleSocietyInfo = 'Completed';
    }
  }
}
